import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  list: {
    height: '55vh',
    overflow: 'auto'
  },
  header: {
    backgroundColor: theme.palette.grey[300],
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative'
  },
  body: {
    marginTop: 8
  },
  providerRow: {
    backgroundColor: theme.palette.grey[100],
    height: 46,
    display: 'flex',
    flexDirection: 'row',
    marginTop: 8,
    alignItems: 'center',
    position: 'relative'
  },
  providerName: {
    position: 'absolute',
    marginLeft: 24
  },
  accommodationName: {
    position: 'absolute',
    marginLeft: 48
  },
  providerCheckbox: {
    marginLeft: 8
  }
}))

export default useStyles
